module.exports = __webpack_public_path__ + "static/media/ftx-logo-blue.f1b402b7.png";